module.exports = __webpack_public_path__ + "static/cocatus-text-2c65be47b61ad092e80fe684105041b4.png";